import moment from 'moment';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { getMtaApBasicData, hydrateApBasicData, refreshApBasicData } from './helpers/basicHelper';
import { addDNoneClass, btnLoading, byId, convertToTwoDecimalInt, insertDataToElementUsingClassName } from './helpers/utility';

import { upiqr } from 'upiqr';

import queryString from 'query-string';
import webApkInterface from './helpers/webApkInterfaceHelper';

authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert

const parsedQuery = queryString.parse(location.search);


if (parsedQuery.transactionStatus) {
    if (parsedQuery.transactionStatus === 'SUCCESS') {
        Swal.fire({
            icon: 'success',
            title: 'Transaction Success 🥰',
            text: 'Credits Successfully Deposited in Your Wallet',

        });
    }
    if (parsedQuery.transactionStatus === 'PENDING') {
        Swal.fire({
            icon: 'info',
            title: 'Transaction Still Pending 😫',
            text: parsedQuery.transactionResponse,

        });
    }
    if (parsedQuery.transactionStatus === 'FAILURE') {
        Swal.fire({
            icon: 'error',
            title: 'Transaction Failed 😢',
            text: parsedQuery.transactionResponse,

        });
    }
}

let totalCredit = convertToTwoDecimalInt(getMtaApBasicData().depositCredit) + convertToTwoDecimalInt(getMtaApBasicData().bonusCredit);

insertDataToElementUsingClassName('total-credits-text-here', totalCredit);
insertDataToElementUsingClassName('deposit-credits-text-here', getMtaApBasicData().depositCredit);
insertDataToElementUsingClassName('bonus-credits-text-here', getMtaApBasicData().bonusCredit);
// refreshing wallet data 
refreshApBasicData().then(() => {
    totalCredit = convertToTwoDecimalInt(getMtaApBasicData().depositCredit) + convertToTwoDecimalInt(getMtaApBasicData().bonusCredit);
    insertDataToElementUsingClassName('total-credits-text-here', totalCredit);
    insertDataToElementUsingClassName('deposit-credits-text-here', getMtaApBasicData().depositCredit);
    insertDataToElementUsingClassName('bonus-credits-text-here', getMtaApBasicData().bonusCredit);
});



// buy more code 

const creditBuyQuantityInput = byId('creditBuyQuantityInput');
const creditBuyTotalAmountInput = byId('creditBuyTotalAmountInput');
const buyMoreSubmitBtn = byId('buyMoreSubmitBtn');

creditBuyQuantityInput.addEventListener('input', function (e) {

    const value = (e.target.value);
    if (value < 100) {

        creditBuyTotalAmountInput.value = 100;

        addDNoneClass(buyMoreSubmitBtn, true);
    } else {
        creditBuyTotalAmountInput.value = value;

        addDNoneClass(buyMoreSubmitBtn, false);
    }




});



// const buyMoreInitBtn = byId('buyMoreInitBtn');
const buyMoreCancelBtn = byId('buyMoreCancelBtn');
const buyMoreCardDivElement = byId('buyMoreCardDivElement');
// buyMoreInitBtn.addEventListener('click', () => {



//     Swal.fire({
//         title: 'Need to Buy Credits?',
//         text: 'Contact Us on What App',
//         icon: 'info',
//         showCancelButton: true,
//         confirmButtonColor: '#3085d6',
//         cancelButtonColor: '#d33',
//         confirmButtonText: 'Open WhatsApp'
//     }).then((result) => {
//         if (result.isConfirmed) {
//             // location.href = './customerSupport.html';
//             // navigate("../customerSupport")
//             webApkInterface.openInBrowser('https://api.whatsapp.com/send/?phone=919834877006');
//         }
//     });




//     // addDNoneClass(buyMoreCardDivElement, false);




// });
buyMoreCancelBtn.addEventListener('click', () => { addDNoneClass(buyMoreCardDivElement, true); });




const initTransactionFun = async () => {

    btnLoading(buyMoreSubmitBtn, '', true);
    const data = {

        txnAmount: parseFloat(creditBuyTotalAmountInput.value).toFixed(2),
        clientLocationUrl: window.location.origin + window.location.pathname


    };

    const upi_id = '7775814761@upi';

    upiqr({
        payeeVPA: upi_id,
        payeeName: 'Adarsh hatkar ',
        amount: data.txnAmount
    })
        .then(async (upi) => {
            // console.log(upi.qr);      // data:image/png;base64,eR0lGODP...
            // console.log(upi.intent);  // upi://pay?pa=bhar4t@upi&pn=Bharat..

            Swal.fire({

                imageUrl: upi.qr,
                imageHeight: 264,
                text: `Pay on above qr using any Upi app (phonepay,paytm,gpay,etc.) in Your Phone , Contact us by clicking Customer Support below if facing any issue`,
                imageAlt: 'A tall image',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Customer Support',
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {

                    webApkInterface.openInBrowser(`https://wa.me/919834877006?text=hello%20sir,%20%20i%20want%20to%20buy%20${data.txnAmount}%20credits%20in%20my%20admin%20panel%20please%20give%20me%20payment%20details%20I%20am%20ready%20to%20pay%20${data.txnAmount}%20Rs`);
                }

                btnLoading(buyMoreSubmitBtn, '', false);
            });



        })
        .catch(err => {
            console.log(err);
        });


    /* removing upi indent  */

    //   await  webApkInterface.openInBrowser(generateUpiLink(data.txnAmount));

    //     setTimeout(() => {
    //         webApkInterface.openInBrowser(`https://wa.me/919834877006?text=hello%20sir,%20%20i%20want%20to%20buy%20${data.txnAmount}%20credits%20in%20my%20admin%20panel%20please%20give%20me%20payment%20details%20I%20am%20ready%20to%20pay%20${data.txnAmount}%20Rs`);
    //         btnLoading(buyMoreSubmitBtn, '', false);
    //     }, 1000 * 5);


    /* removing paytmPrimexopCat from here */
    // paytm code below 

    // callTheApServerPost('/paytm/init', { data: data }).then((response) => {
    //     axiosResponseHandler(response);
    //     const res = response.data;






    //     if (res.status === 'success') {
    //         console.log(res);
    //         const { orderId, token, txnAmount } = res;


    //         const txnAmountValue = txnAmount.value;
    //         loadJsCheckoutLibrary();
    //         initPaytmJsCheckout(orderId, token, txnAmountValue);

    //     }
    // }).catch((error) => {
    //     axiosErrorHandler(error);
    //     console.log(error);
    // });
};

buyMoreSubmitBtn.addEventListener('click', initTransactionFun);


// withdraw code below 
const withdrawInitBtn = byId('withdrawInitBtn');
const withdrawCancelBtn = byId('withdrawCancelBtn');
const withdrawCardDivElement = byId('withdrawCardDivElement');
// console.log(withdrawInitBtn);
withdrawInitBtn.addEventListener('click', () => { addDNoneClass(withdrawCardDivElement, false); });
withdrawCancelBtn.addEventListener('click', () => { addDNoneClass(withdrawCardDivElement, true); });

const creditWithdrawMethodNameSelectInput = byId('creditWithdrawMethodNameSelectInput');
const creditWithdrawMethodIdInputLabelElement = byId('creditWithdrawMethodIdInputLabelElement');

const creditWithdrawMethodSelectFun = () => {
    if (creditWithdrawMethodNameSelectInput.value === 'UPI') {
        creditWithdrawMethodIdInputLabelElement.innerText = 'UPI ID (Ex: 983487xxxx@upi)';
    } else {
        creditWithdrawMethodIdInputLabelElement.innerText = `${creditWithdrawMethodNameSelectInput.value} Wallet Number (Ex: 9834xxxx06)`;
    }
};
creditWithdrawMethodSelectFun();
creditWithdrawMethodNameSelectInput.addEventListener('input', creditWithdrawMethodSelectFun);


const creditWithdrawQuantityInput = byId('creditWithdrawQuantityInput');

const creditWithdrawChargeInput = byId('creditWithdrawChargeInput');
const creditWithdrawFinalAmountInput = byId('creditWithdrawFinalAmountInput');
const withdrawSubmitBtn = byId('withdrawSubmitBtn');

const withdrawCalculationsFun = () => {


    const value = creditWithdrawQuantityInput.value;
    if (value < 6) {


        creditWithdrawFinalAmountInput.value = creditWithdrawChargeInput.value = 0;

        addDNoneClass(withdrawSubmitBtn, true);
    } else {
        addDNoneClass(withdrawSubmitBtn, false);

        if (value < 100) {

            creditWithdrawChargeInput.value = 5;
            creditWithdrawFinalAmountInput.value = value - creditWithdrawChargeInput.value;
        } else {
            creditWithdrawChargeInput.value = (5 * value) / 100;
            creditWithdrawFinalAmountInput.value = value - creditWithdrawChargeInput.value;
        }
    }





};
withdrawCalculationsFun();

creditWithdrawQuantityInput.addEventListener('input', withdrawCalculationsFun);

const creditWithdrawMethodIdInput = byId('creditWithdrawMethodIdInput');

const withdrawRequestFun = () => {
    const data = {
        methodName: creditWithdrawMethodNameSelectInput.value,
        methodId: creditWithdrawMethodIdInput.value,
        amount: creditWithdrawQuantityInput.value,
    };
    callTheApServerPost(`/wallet/withdrawRequest`, { data: data }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);
            Swal.fire({
                icon: 'success',
                title: 'Withdraw Requested Success',
                text: 'Withdrawed Funds will be transferred your (Bank /Wallet) in Next 24 to 48 Hr ',

            });

            setTimeout(() => { location.href = window.location.origin + window.location.pathname; }, 3000);



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

withdrawSubmitBtn.addEventListener('click', withdrawRequestFun);


// get wallet history

let skip = 0;
const walletHistoryTableLoadMoreDivElement = byId('walletHistoryTableLoadMoreDivElement');


const fetchWalletHistory = () => {
    addDNoneClass(walletHistoryTableLoadMoreDivElement, true);

    callTheApServerGet(`/wallet/walletHistory/${skip}/10`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




        const walletHistoryTableBodyElement = byId('walletHistoryTableBodyElement');
        const walletHistoryTableNoDataRowElement = byId('walletHistoryTableNoDataRowElement');

        if (res.status === 'success') {
            console.log(res);

            const walletHistoryData = res.walletHistoryData;
            let i = 0;
            skip += 10;




            if (walletHistoryData.length > 0) {
                addDNoneClass(walletHistoryTableLoadMoreDivElement, false);
                addDNoneClass(walletHistoryTableNoDataRowElement, true);


                while (i < walletHistoryData.length) {

                    const date = moment(walletHistoryData[i].createdAt * 1000).format('DD/MM/YYYY');
                    const time = moment(walletHistoryData[i].createdAt * 1000).format('LT');

                    walletHistoryTableBodyElement.innerHTML += `
                    <tr>
                       
                        <td>${walletHistoryData[i].sn}</td>
                    
                        <td>${walletHistoryData[i].walletType}</td>
                        <td>${walletHistoryData[i].transactionType}</td>
                        <td>${parseFloat(walletHistoryData[i].amount).toFixed(2)} Credits</td>
                        <td>${parseFloat(walletHistoryData[i].closingBalance).toFixed(2)} Credits</td>
                        <td>${date} <br> ${time}</td>
                        <td>${walletHistoryData[i].comment}</td>
                    </tr>
                    `;
                    i++;
                }
            }

            if (walletHistoryData.length === 0) {




                if (skip === 0) {
                    walletHistoryTableNoDataRowElement.innerHTML = `
                    <th class='text-center' colspan='6'>No Wallet Transactions Found 😥</th> 
                    `;
                } else {
                    addDNoneClass(walletHistoryTableLoadMoreDivElement, true);
                }
            } else {
                addDNoneClass(walletHistoryTableLoadMoreDivElement, false);
            }



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

fetchWalletHistory();




walletHistoryTableLoadMoreDivElement.addEventListener('click', fetchWalletHistory);
